import { Stack, SxProps, TextField, Theme } from '@mui/material'
import { ChangeEvent } from 'react'

import useUrlParams from '@/hooks/useUrlParams'
import removeNullishValues from '@/utils/removeNullishValues'
import { WithChildren } from '@/utils/types'

import { ArchiveSelector, GridListFilter, SortBySelector } from './components'

export type SearchToolbarProps = WithChildren<{
  searchTitle: string
  sortOptions?: { value: string; text: string }[]
  defaultSort?: string
  withCards?: boolean
  sx?: SxProps<Theme>
  archiveSelector?: boolean
}>

/**
 * This is the default search toolbar used in most of the list screens.
 * @param props
 * @constructor
 */
export const SearchToolbar = (props: SearchToolbarProps) => {
  const { searchTitle, defaultSort, children, withCards, archiveSelector } =
    props
  const [searchParams, setSearchParams] = useUrlParams()
  const { search = '' } = searchParams

  const onSearch = (e: ChangeEvent<HTMLInputElement>) => {
    const search = e.target.value
    setSearchParams(removeNullishValues({ search }))
  }

  return (
    <Stack
      alignItems={['stretch', 'center']}
      direction={['column', 'row']}
      justifyContent="space-between"
      mb={2}
      spacing={2}
      sx={props.sx}
    >
      <TextField
        id="name"
        label={searchTitle}
        sx={{ flex: 1 }}
        value={search}
        variant="outlined"
        onChange={onSearch}
      />
      <Stack direction="row" gap={2} justifyContent="space-around">
        {defaultSort ? <SortBySelector {...props} /> : null}
        {withCards ? <GridListFilter /> : null}
        {archiveSelector ? <ArchiveSelector /> : null}
        {children}
      </Stack>
    </Stack>
  )
}
